module.exports = __webpack_public_path__ + "img/logo-fulcri-neg.fa30028a.svg";